module.exports = __webpack_public_path__ + "fonts/Euclid Circular B Bold Italic.86fe7bf2.woff";